import type { Archetype, Checkpoint, StepApprovers, StepNotifications, LinkedEntity } from '@/graph/domain/types';

export interface RecommendedInstrumentRef {
  value: string;
  workspaceId: string;
}

export interface AddStepModalProps {
  sourceMaterialId: string;
  sourceMaterialIds?: string[];
  archetypes?: Archetype[];
  mode?: 'add' | 'insert';
  onClose: () => void;
  onSaved?: (
    operationId: string,
    downstreamMaterialId: string,
    operationMeta?: {
      operationTemplate?: {
        operationTypeId: string;
        parameters?: Array<{ parameterName?: string; value?: unknown; unit?: string; fieldType?: string; required?: boolean; tags?: string[] }>;
        hideParamsMap?: Record<string, boolean>;
        translationTemplate?: string;
      };
      operationTypeId?: string;
      stepVertexId?: string;
    }
  ) => void;
}

export interface AddStepFormState {
  selectedOperationTypeId: string | null;
  parameterValues: Record<string, unknown>;
  linkedEntityParameters?: Record<string, LinkedEntity[]>; // For linkEntity field type parameters
  yieldValue: number | null;
  yieldIsPercent: boolean;
  durationHours: number;
  durationMinutes: number;
  durationSeconds: number;
  linkToPreviousStep: boolean;
  linkedStepId: string | null;
  notes: string;
  recommendedInstrument: RecommendedInstrumentRef[];
  approvers: StepApprovers;
  notifications: StepNotifications;
  checkpoints: Checkpoint[];
}

export const INITIAL_FORM_STATE: AddStepFormState = {
  selectedOperationTypeId: null,
  parameterValues: {},
  linkedEntityParameters: {},
  yieldValue: null,
  yieldIsPercent: true,
  durationHours: 0,
  durationMinutes: 0,
  durationSeconds: 0,
  linkToPreviousStep: false,
  linkedStepId: null,
  notes: '',
  recommendedInstrument: [],
  approvers: { approverType: null, users: [] },
  notifications: { notificationType: null, users: [] },
  checkpoints: [],
};
